import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[wf-process-step-optional-activity-directive]',
    standalone: false
})
export class WfProcessStepOptionalActivityDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
